.basicSubstepContainer {
	border: 1px solid #dedede;
	display: flex;
	flex-direction: column;
	border-radius: 10px;
	padding: 0.9375rem;
	gap: 1.25rem;

	container-type: inline-size;
	container-name: substepContainer;
}

@container substepContainer (max-width: 800px) {
	.basicSubstepContainer > div {
		flex-direction: column !important;
		gap: 1rem !important;
		justify-content: center;
	}

	/* Generically fix the flex children inside that wrapper */
	.basicSubstepContainer > div > * {
		flex: unset !important;
		min-height: unset;
		max-height: unset;
		min-width: unset;
		max-width: 100%;
		margin-right: 0 !important;
	}
}

div.basicSubstepHeaderWrapper {
	display: flex;
	flex-direction: row;
	gap: 0.625rem;
	width: 70%;
}

div.basicSubstepTextWrapper {
	display: flex;
	flex-direction: column;
	gap: 0.3125rem;
	width: 100%;
}

h2.basicSubstepTitle {
	color: #212121;
	font-size: 1rem;
	font-weight: 600;
	line-height: 1.5;
}

p.basicSubstepDescription {
	color: #525252;
	font-size: 0.9375rem;
	font-weight: 400;
	line-height: 1.5;
}

div.basicStepContainer {
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	width: 100%;
}

p.stepDescription {
	color: #6b6b6b;
	font-weight: 400;
	font-size: 0.9375rem;
	line-height: 1.5;
	padding-right: 30px;
	margin-top: 0.5rem;
}

.guideContainer {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	background-color: #fbf8ff;
	width: 100%;
	padding: 0.625rem 0.9375rem;
	border-radius: 10px;
	border: 1px solid #ebddff;
	gap: 3rem;
}

.guideTextWrapper {
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	justify-content: center;
	flex: 1 1 20%;
}

.guideTitleWrapper {
	display: flex;
	flex-direction: row;
	gap: 0.5rem;
	align-items: center;
}

.guideTitleWrapper svg {
	flex-shrink: 0;
}

p.guideTitle {
	color: #42296e;
	font-weight: 500;
	font-size: 0.9375rem;
	line-height: 1.5;
}

p.guideDescription {
	color: #525252;
	font-size: 0.9375rem;
	font-weight: 400;
	line-height: 1.5;
}

.guideVideo {
	border-radius: 4px;
	height: auto;
	width: auto;
	border: none;
	flex-shrink: 1;
	flex-basis: 28%;
	aspect-ratio: 16/9;
	max-height: 200px;
}

div.deviceContainer {
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	width: 100%;
}

p.deviceLabel {
	display: flex;
	align-items: center;
	gap: 10px;
	color: #212121;
	font-weight: 500;
	font-size: 0.9375rem;
	line-height: 1.5;
}

svg.deviceLabelIcon {
	font-size: 20px;
}

div.deviceDropdown {
	height: 35px;
	max-width: 400px;
	min-width: 300px;
}

div.deviceDropdown :global(.MuiSelect-select) {
	padding: 7px 40px 7px 8px;
}

li.deviceDropdownEntry {
	display: flex;
	align-items: center;
	gap: 7px;
}

svg.deviceDropdownIcon {
	font-size: 20px;
	color: #6f6f6f;
}

div.cameraPreviewContainer {
	display: flex;
	width: 100%;
	height: 100%;
	border-radius: 8px;
	justify-content: center;
	align-items: center;
	min-height: 0;
	aspect-ratio: 640/480;
}

div.cameraError {
	background-color: #191919;
}

div.cameraError p {
	color: #fff;
	font-size: 0.9375rem;
	font-weight: 600;
	line-height: 1.5;
}

.videoCanvas {
	transform: rotateY(180deg);
	border-radius: 8px;
	width: 100%;
	height: 100%;
	object-fit: contain;
	background: black;
}

div.waveformContainer {
	display: flex;
	align-items: center;
	border: 1px solid #6f6f6f;
	padding: 0.625rem 0.3125rem;
	border-radius: 8px;
	width: 100%;
	justify-content: center;
}

div.progressContainer {
	display: flex;
	flex-direction: row;
	width: 100%;
	gap: 1.25rem;
	align-items: center;
}

div.progressContainer p {
	color: #212121;
	font-size: 1.125rem;
	font-weight: 500;
	line-height: 1.4;
}

div.beforeQuizStepperContainer {
	background-color: #fbfbfb;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	height: 100%;
	width: 100%;
	border-radius: 20px;
	border: 1px solid #e2e2e2;
	padding: 1.25rem 0.5rem 2rem 0.5rem;
	overflow: auto;

	div.stepperTitleWrapper {
		display: flex;
		flex-direction: column;
		gap: 0.3125rem;
		flex-wrap: wrap;
		align-items: center;
		justify-content: center;
	}

	div.stepperTitleWrapper h1 {
		color: #333333;
		font-size: 1rem;
		font-weight: 600;
		line-height: 1.4;
		text-align: center;
		white-space: pre-line;
	}

	::-webkit-scrollbar-track {
		margin-right: 0.3125rem;
	}
}

@media (max-width: 480px) {
	h2.basicSubstepTitle {
		text-align: center;
	}
	div.basicSubstepHeaderWrapper {
		flex-direction: column;
		align-items: center;
	}
	div.guideTitleWrapper {
		flex-direction: column;
	}

	p.guideTitle {
		text-align: center;
	}

	div.guideContainer {
		padding-top: 1rem;
	}
}

@media (max-width: 600px) {
	div.deviceDropdown {
		width: 100%;
		min-width: unset;
	}
}

@media (max-width: 900px) {
	div.basicSubstepHeaderWrapper {
		width: 100%;
	}

	div.guideContainer {
		flex-direction: column;
		gap: 1rem;
	}

	.guideVideo {
		width: fit-content;
	}
}

.floatingButton {
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: visible;
	transform: translate(-16px, -16px);
}

.floatingButton:hover,
.floatingButton:active {
	background-color: transparent !important;
}

.supportChatContainer {
	position: absolute;
	bottom: 0;
	right: 1rem;
	z-index: 10;
	font-family: sans-serif;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	/* max-height: 100%; */
	/* min-height: 0; */
}

.supportChatWindow {
	width: 100%;
	height: 100%;
	background-color: #ffffff;
	border-radius: 20px;
	border: 1px solid #e0e0e0;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	margin-bottom: 15px;
	overflow: hidden;
	/* min-height: 0; */
	opacity: 1;
	transform: rotate(0deg);
}

.supportChatHeader {
	padding: 12px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.headerLeft {
	display: flex;
	align-items: center;
	gap: 8px;
	color: #333333;
	font-family: Inter, sans-serif;
	font-weight: 500;
	font-size: 14px;
	line-height: 24px;
	letter-spacing: -0.3px;
}

.headerTitle {
	font-weight: 600;
}

.supportChatCloseButton {
	background: none;
	border: none;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	padding: 0;
}

.supportChatCloseButton svg {
	width: 100%;
	height: 100%;
	display: block;
}

.supportChatCloseButton:hover {
	color: #000;
}

.messagesArea {
	flex: 1;
	/* min-height: 0; */
	padding: 15px;
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.userMessage {
	align-self: flex-end;
	max-width: 286px;
	width: fit-content;
	margin-left: 16px;
	background: #f5f5f5;
	box-shadow: 0px 1px 2px -1px rgba(0, 0, 0, 0.1);
	border-radius: 24px 8px 24px 24px;
	padding: 12px 15px;
	color: #212121;
	font-size: 14px;
	line-height: 1.4;
	display: flex;
	flex-direction: column;
	gap: 4px;
	overflow-wrap: break-word;
	word-break: break-word;
}

.aiMessageWrapper {
	align-self: flex-start;
	display: flex;
	flex-direction: column;
	gap: 6px;
	width: 100%;
	padding-right: 16px;
	box-sizing: border-box;
}

.aiMessage {
	width: 100%;
	background: #fbf8ff;
	box-shadow: 0px 1px 2px -1px rgba(0, 0, 0, 0.1);
	border-radius: 8px 24px 24px 24px;
	padding: 12px;
	color: #212121;
	font-size: 14px;
	line-height: 1.4;
	overflow-wrap: break-word;
	word-break: break-word;
}

.aiMessage ol li {
	margin-bottom: 8px; /* Adds space between the steps */
}

/* Removes the margin from the very last item so it doesn't create unwanted extra space at the bottom of the chat bubble */
.aiMessage ol li:last-child {
	margin-bottom: 0;
}

/* Removes default margins from paragraphs generated by react-markdown */
.aiMessage p,
.userMessage p {
	margin: 0;
}

/* Adds a little space if the AI outputs multiple paragraphs */
.aiMessage p + p,
.userMessage p + p {
	margin-top: 5px;
}

.interactiveCommandButton {
	display: flex;
	align-items: center;
	justify-content: center;

	margin-top: 15px;
	margin-left: auto;
	margin-right: auto;

	width: 95%;
	min-height: 40px;
	border-radius: 300px;
	padding: 10px 15px;
	text-decoration: none;

	cursor: pointer;
	font-family: Inter;
	font-weight: 500;
	font-size: 14px;
	line-height: 140%;

	background: var(--primary-background-color);
	border: 1px solid var(--primary-border-color);
	color: var(--primary-font-color);
	transition: all 0.1s ease-in-out;
}

.interactiveCommandButton:hover {
	background: var(--primary-hover-background-color);
	color: var(--primary-hover-font-color);
}

.interactiveCommandButton svg path {
	stroke: var(--primary-border-color);
	transition: stroke 0.1s ease-in-out;
}

.interactiveCommandButton:hover svg path {
	stroke: var(--primary-hover-font-color);
}

.interactiveCommandButton:focus-visible {
	outline: 2px solid var(--focus-outline-color-dark);
	outline-offset: 2px;
}

.buttonContentWrapper {
	display: inline-flex;
	align-items: center;
	justify-content: flex-start;
	gap: 5px;
	max-width: 100%;

	svg {
		flex-shrink: 0;
	}

	span {
		white-space: normal;
		word-break: break-word;
	}
}

.inputArea {
	width: 100%;
	height: 74px;
	padding: 12px;
	display: flex;
	align-items: center;
	gap: 10px;
	box-sizing: border-box;
	opacity: 1;
	transform: rotate(0deg);
	background-color: #ffffff;
}

.defaultTextFieldWrapper {
	flex: 1;
	min-width: 0;
	height: 50px;
	border-radius: 12px;
	border: 1px solid #e5e7eb;
	background-color: #ffffff;
	box-shadow: 0px 2.31px 5.77px 0px rgba(0, 0, 0, 0.1);
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 4px 4px 4px 15px;
	box-sizing: border-box;
}

.activeTextFieldWrapper {
	border: 1px solid #c496ff;
	box-shadow: 0px 2.18px 5.44px 0px #a855f71a;
}

.textInput {
	flex: 1;
	min-width: 0;
	border: none;
	outline: none;
	background: transparent;
	font-size: 14px;
	color: #212121;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	&:focus-visible {
		outline: 2px solid var(--focus-outline-color-dark);
		outline-offset: 2px;
		background-color: rgba(0, 0, 0, 0.04);
	}
}

.sendButton {
	flex-shrink: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 40px;
	height: 40px;
	flex-shrink: 0;
	border: none;
	border-radius: 14px;
	background-color: transparent;
	cursor: pointer;
	box-shadow: 0px 4px 6px -4px rgba(0, 0, 0, 0.1);
	transition:
		box-shadow 0.2s ease,
		opacity 0.2s ease;
	overflow: hidden;
	padding: 0;
}

.activeSendButton {
	box-shadow:
		0px 4px 6px -4px #7c3aed1a,
		0px 10px 15px -3px #7c3aed1a;
}

/* Disabled state */
.sendButton:disabled {
	cursor: not-allowed;
}

.sendButton svg {
	width: 100%;
	height: 100%;
	display: block;
}
